import React, {Fragment, useEffect, useState, useRef} from "react";
import { DispatchContext, StateContext } from "../../containers/sidebarContext";
import classNames from "classnames";
import shelbyBarLogo from "../../assets/pictures/shelbyLogo-removebg.png";
import {FaSortDown, FaSortUp} from 'react-icons/fa';
import {changeLanguage} from "../../i18n";
import { useOnClickOutside } from "../../utils/customHooks";

const Header = () => {
  const dispatch = React.useContext(DispatchContext);
  const state = React.useContext(StateContext);
  const [islanguageOpen, setLanguageModal] = useState(false);
  const { isSidebarOpen, language } = state;
  const ref = useRef();

  const animatedHamburgerMenu = classNames({
    "animated-icon2": true,
    open: !isSidebarOpen,
  });
  const languageCSS = classNames({
    "open":islanguageOpen,
    "close":!islanguageOpen
  });

  const bacgroundImageLNG = {
    backgroundRepeat: "no-repeat",
  backgroundSize: "25px 14px",
    backgroundImage: language==="de" ? `url(https://www.worldometers.info/img/flags/gm-flag.gif)`:
        language==="en" ? `url(https://www.worldometers.info/img/flags/uk-flag.gif)` :
            `url(https://www.worldometers.info/img/flags/hr-flag.gif)`
  };

  function toggleSidebar(){
    dispatch({ type: "toggleSidebar", payload: isSidebarOpen })
  }
  useOnClickOutside(ref, () => setLanguageModal(false));

  function _changeLanguage(lang){
    if(language !== lang){
      dispatch({ type: "toggleLanguage", payload: lang })
      changeLanguage(lang)
      //close language modal
      setLanguageModal(false)
    }
  }

  useEffect(() => {
    changeLanguage(language)
  }, []);
  
  return (
    <Fragment>
      <div id="content">
        <nav className="navbar red lighten-1">
          <button
            onClick={() => toggleSidebar()}
            className="navbar-toggler second-button collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent23"
            aria-controls="navbarSupportedContent23"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <div className={animatedHamburgerMenu}>
              <span />
              <span />
              <span />
              <span />
            </div>
          </button>
          <span className="navbar-logo">
            <img className="navbar-logo-position" src={shelbyBarLogo} alt="flowers"/>
          </span>
          <div className="logo">
            <a href="#"><img src="https://bluebits.dev/wp-content/uploads/2020/06/cropped-logo-1.png" alt=""/></a>
          </div>
          <div ref={ref} className="lang-menu">
            <div onClick={()=>setLanguageModal(true)} className="selected-lang"
            style={bacgroundImageLNG}
            >
              {islanguageOpen ?
                <div className="fa-sort-up"><FaSortUp/></div>:<div className="fa-sort-down"><FaSortDown/></div>}
            </div>
            <ul className={languageCSS}>
              <li onClick={() => _changeLanguage("de")}>
                <a href="#" className="de">DE</a>
              </li>
              <li onClick={() => _changeLanguage("en")}>
                <a href="#" className="en">EN</a>
              </li>
              <li onClick={() => _changeLanguage("hr")}>
                <a href="#" className="hr">HR</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </Fragment>
  );
};

export default Header;
